/** Spanish labels mirroring api-core MotivoStock descriptions. */
const MOTIVO_STOCK_LABELS = {
    TRANSFERENCIA_SUCURSAL: 'Se transfirio stock entre sucursales',
    VENTA: 'Descontado por venta',
    COMPRA: 'Ingreso de articulos por compra a proveedor',
    MODIFICACION_MANUAL: 'Esta cantidad se modifico manualmente',
    INGRESO_ARTICULO: 'Se agrego un articulo nuevo con una cantidad inicial',
    CANCELACION_TRANSFERENCIA:
        'Una transferencia fue cancelada, se agrega stock',
    VENTA_CANCELADA: 'Una venta fue cancelada, se agrega stock',
    COMPRA_CANCELADA: 'Una compra fue eliminada, se descuenta stock',
    COMPRA_RECUPERADA: 'Una compra fue recuperada, se agrega stock',
}

/**
 * Maps MotivoStock enum NAME to end-user Spanish label.
 * Unknown/empty values fall back to raw string or ''.
 */
export function motivoStockLabel(motivo) {
    if (motivo == null || motivo === '') return ''
    return MOTIVO_STOCK_LABELS[motivo] || motivo
}
